export default __webpack_public_path__ + "static/media/uigradients.d9efd320.svg";